import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthService } from './auth/auth.service';

let isRefreshing = false;
const refreshTokenSubject = new BehaviorSubject<boolean>(false);

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (req.url.endsWith('/account/refresh')) {
    return next(req);
  }

  const addAuthToken = (request: HttpRequest<any>): HttpRequest<any> => {
    const token = authService.getAccessToken();
    return token
      ? request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
      : request;
  };

  const handle401Error = (
    request: HttpRequest<any>
  ): Observable<HttpEvent<any>> => {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshTokenSubject.next(false);

      return authService.refreshToken().pipe(
        switchMap(() => {
          isRefreshing = false;
          refreshTokenSubject.next(true);
          return next(addAuthToken(request));
        }),
        catchError((error: HttpErrorResponse) => {
          isRefreshing = false;
          refreshTokenSubject.error(error);
          authService.login();
          return throwError(() => error);
        })
      );
    }

    return refreshTokenSubject.pipe(
      filter(success => success),
      take(1),
      switchMap(() => next(addAuthToken(request))),
      catchError(error => throwError(() => error))
    );
  };

  return next(addAuthToken(req)).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return handle401Error(req);
      }
      return throwError(() => error);
    })
  );
};
